/* ═══════════════════════════════════════════
   LEIBEN THEME JS — v2.0
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── Tab switching (Support page) ── */
  function initTabs() {
    var tabBtns = document.querySelectorAll('.tab-btn, .quick-btn[data-tab]');
    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var tabName = this.getAttribute('data-tab');
        if (!tabName) return;

        // Update tab buttons
        document.querySelectorAll('.tab-btn').forEach(function(b) {
          b.classList.toggle('active', b.getAttribute('data-tab') === tabName);
        });

        // Update tab content
        document.querySelectorAll('.tab-content').forEach(function(c) {
          c.classList.toggle('active', c.id === 'tab-' + tabName);
        });
      });
    });
  }

  /* ── FAQ accordion ── */
  function initFAQ() {
    document.querySelectorAll('.faq-question').forEach(function(q) {
      q.addEventListener('click', function() {
        var item = this.closest('.faq-item');
        var wasActive = item.classList.contains('active');

        // Close all others
        document.querySelectorAll('.faq-item.active').forEach(function(i) {
          i.classList.remove('active');
        });

        // Toggle current
        if (!wasActive) {
          item.classList.add('active');
        }
      });
    });
  }

  /* ── FAQ search filtering ── */
  function initSearch() {
    var searchInput = document.getElementById('searchInput');
    if (!searchInput) return;

    searchInput.addEventListener('input', function() {
      var query = this.value.toLowerCase().trim();
      var faqItems = document.querySelectorAll('.faq-item');

      if (query.length < 2) {
        faqItems.forEach(function(item) { item.style.display = ''; });
        return;
      }

      // Switch to FAQ tab if searching
      var faqTab = document.querySelector('.tab-btn[data-tab="faq"]');
      if (faqTab && !faqTab.classList.contains('active')) {
        faqTab.click();
      }

      faqItems.forEach(function(item) {
        var text = item.textContent.toLowerCase();
        item.style.display = text.indexOf(query) > -1 ? '' : 'none';
      });
    });
  }

  /* ── Contact form path switching ── */
  function initContactPaths() {
    var btnCustomer = document.getElementById('btn-customer');
    var btnDealer = document.getElementById('btn-dealer');
    var panelCustomer = document.getElementById('panel-customer');
    var panelDealer = document.getElementById('panel-dealer');

    if (!btnCustomer || !btnDealer) return;

    function switchTo(path) {
      btnCustomer.classList.toggle('active', path === 'customer');
      btnDealer.classList.toggle('active', path === 'dealer');
      if (panelCustomer) panelCustomer.classList.toggle('active', path === 'customer');
      if (panelDealer) panelDealer.classList.toggle('active', path === 'dealer');
    }

    btnCustomer.addEventListener('click', function() { switchTo('customer'); });
    btnDealer.addEventListener('click', function() { switchTo('dealer'); });

    // Make available globally for inline onclick handlers
    window.switchPath = switchTo;
  }

  /* ── Dealer country/state logic ── */
  function initDealerCountry() {
    var countrySelect = document.getElementById('dealer-country');
    if (!countrySelect) return;

    var US_STATES = [
      "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut",
      "Delaware","District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois",
      "Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts",
      "Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada",
      "New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota",
      "Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina",
      "South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington",
      "West Virginia","Wisconsin","Wyoming"
    ];
    var CA_PROVINCES = [
      "Alberta","British Columbia","Manitoba","New Brunswick",
      "Newfoundland and Labrador","Northwest Territories","Nova Scotia",
      "Nunavut","Ontario","Prince Edward Island","Quebec","Saskatchewan","Yukon"
    ];

    countrySelect.addEventListener('change', function() {
      var val = this.value;
      var stateField = document.getElementById('state-field');
      var stateLabel = document.getElementById('state-label');
      var stateSelect = document.getElementById('dealer-state');
      var otherField = document.getElementById('other-country-field');

      if (stateSelect) stateSelect.innerHTML = '';
      if (stateField) stateField.classList.remove('visible');
      if (otherField) otherField.style.display = 'none';

      if (val === 'US') {
        if (stateLabel) stateLabel.innerHTML = 'State<span class="req">*</span>';
        if (stateSelect) {
          stateSelect.innerHTML = '<option value="" disabled selected>Select state</option>' +
            US_STATES.map(function(s) { return '<option>' + s + '</option>'; }).join('');
        }
        if (stateField) stateField.classList.add('visible');
      } else if (val === 'CA') {
        if (stateLabel) stateLabel.innerHTML = 'Province / Territory<span class="req">*</span>';
        if (stateSelect) {
          stateSelect.innerHTML = '<option value="" disabled selected>Select province</option>' +
            CA_PROVINCES.map(function(s) { return '<option>' + s + '</option>'; }).join('');
        }
        if (stateField) stateField.classList.add('visible');
      } else if (val === 'OTHER') {
        if (otherField) otherField.style.display = 'block';
      }
    });

    // Also make available globally
    window.onCountryChange = function() {
      countrySelect.dispatchEvent(new Event('change'));
    };
  }

  /* ── AJAX Add to Cart ── */
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
      /* Skip quick-view buttons — they have their own handler */
      if (btn.closest('#qvForm')) return;

      btn.addEventListener('click', function(e) {
        var form = this.closest('form');
        if (!form) return;

        e.preventDefault();

        /* Prevent double-submit while a request is already in flight */
        if (btn.getAttribute('aria-busy') === 'true' || btn.disabled) return;

        /*
         * Capture the CURRENT visible text — not data-original-text — because
         * preorder products show "Pre-Order" (or "Pre-Order – $X" on the CTA)
         * while data-original-text is the static fallback "Buy". Reverting to
         * the static value would clobber the preorder label.
         */
        var originalText = this.textContent.trim() || this.getAttribute('data-original-text') || 'Buy';
        var statusEl = (form.parentElement && form.parentElement.querySelector('[data-cart-status]'))
          || document.querySelector('[data-cart-status]');

        /* Pending state: spinner + accessible busy + screen-reader announcement */
        this.setAttribute('aria-busy', 'true');
        this.disabled = true;
        this.innerHTML = '<span class="pdp-spinner" aria-hidden="true"></span>Adding…';
        if (statusEl) statusEl.textContent = 'Adding to cart…';

        /*
         * Use JSON instead of FormData to prevent duplicate line items.
         * FormData includes form_type + authenticity_token which can cause
         * Shopify to create separate cart lines for the same variant.
         */
        var variantId = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var id = variantId ? parseInt(variantId.value) : null;
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        if (!id) {
          btn.removeAttribute('aria-busy');
          btn.innerHTML = originalText;
          btn.disabled = false;
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          btn.removeAttribute('aria-busy');

          if (data.status && data.status === 422) {
            /* Shopify returned an error (e.g. inventory limit) */
            var msg = data.description || 'Not available';
            btn.textContent = msg;
            if (statusEl) statusEl.textContent = msg;
            setTimeout(function() {
              btn.innerHTML = originalText;
              btn.disabled = false;
              if (statusEl) statusEl.textContent = '';
            }, 2500);
            return;
          }

          /* Success */
          btn.innerHTML = '<span class="pdp-success-mark" aria-hidden="true">✓</span>Added!';
          if (statusEl) statusEl.textContent = 'Added to cart';

          /* Optional haptic feedback on touch devices — guarded for safety */
          if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
            try { navigator.vibrate(10); } catch (e) { /* no-op */ }
          }

          setTimeout(function() {
            btn.innerHTML = originalText;
            btn.disabled = false;
            if (statusEl) statusEl.textContent = '';
          }, 1500);

          /* Update cart count in header */
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var badges = document.querySelectorAll('.cart-count');
              badges.forEach(function(b) {
                b.textContent = cart.item_count;
                b.style.display = cart.item_count > 0 ? '' : 'none';
              });
            });
        })
        .catch(function() {
          btn.removeAttribute('aria-busy');
          btn.textContent = 'Error — try again';
          if (statusEl) statusEl.textContent = 'Could not add to cart. Please try again.';
          setTimeout(function() {
            btn.innerHTML = originalText;
            btn.disabled = false;
            if (statusEl) statusEl.textContent = '';
          }, 2500);
        });
      });
    });
  }

  /* ── Refresh cart count from server (for bfcache / visibility restore) ── */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-count').forEach(function(b) {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function() { /* network errors are non-fatal here */ });
  }

  /* ── Cart page quantity updates ── */
  function initCartPage() {
    document.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-key');
        var delta = parseInt(this.getAttribute('data-delta'));
        var qtySpan = this.parentElement.querySelector('.cart-qty-value');
        var newQty = Math.max(0, parseInt(qtySpan.textContent) + delta);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
        .then(function() { window.location.reload(); });
      });
    });
  }

  /* ── Quick View Modal ── */
  function initQuickView() {
    var overlay = document.getElementById('quickViewOverlay');
    if (!overlay) return;

    var currentProductData = null;
    var isPreorderProduct = false;
    var selectedVariantId = null;

    // Close modal handlers
    overlay.querySelectorAll('[data-qv-close]').forEach(function(el) {
      el.addEventListener('click', closeQuickView);
    });

    // ESC key closes modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeQuickView();
      }
    });

    function closeQuickView() {
      overlay.classList.remove('active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      currentProductData = null;
      selectedVariantId = null;
    }

    function openQuickView(handle) {
      // Show modal with loading state
      overlay.classList.add('active');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var body = overlay.querySelector('.qv-body');
      body.innerHTML = '<div class="qv-loading"><div class="qv-spinner"></div></div>';

      // Fetch product data from Shopify JSON endpoint
      fetch('/products/' + handle + '.js')
        .then(function(res) { return res.json(); })
        .then(function(product) {
          currentProductData = product;
    var _tgs=(product.tags||[]);if(typeof _tgs==="string")_tgs=_tgs.split(",");_tgs=_tgs.map(function(t){return t.trim().toLowerCase();});isPreorderProduct=_tgs.indexOf("preorder")>-1||_tgs.indexOf("pre-order")>-1;
          renderQuickView(product);
        })
        .catch(function() {
          body.innerHTML = '<div class="qv-loading" style="flex-direction:column;gap:12px"><p style="color:var(--storm-grey)">Could not load product.</p></div>';
        });
    }

    function renderQuickView(product) {
      var body = overlay.querySelector('.qv-body');

      // Build image gallery HTML with arrows
      var qvImgHtml = '<div class="qv-image" id="qvImageWrap">';
      if (product.images && product.images.length > 1) {
        product.images.forEach(function(imgUrl, i) {
          qvImgHtml += '<img class="qv-gallery-img' + (i > 0 ? ' qv-img-hidden' : '') + '" src="' + imgUrl + '" alt="' + product.title + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '" data-qv-img-index="' + i + '">';
        });
        qvImgHtml += '<button class="qv-img-arrow qv-img-arrow--prev" data-qv-arrow="prev" aria-label="Previous image"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg></button>';
        qvImgHtml += '<button class="qv-img-arrow qv-img-arrow--next" data-qv-arrow="next" aria-label="Next image"><svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg></button>';
        qvImgHtml += '<div class="qv-img-dots">';
        product.images.forEach(function(_, i) {
          qvImgHtml += '<button class="qv-img-dot' + (i === 0 ? ' active' : '') + '" data-qv-dot="' + i + '" aria-label="Image ' + (i + 1) + '"></button>';
        });
        qvImgHtml += '</div>';
      } else {
        qvImgHtml += '<img id="qvImage" src="" alt="" loading="lazy">';
      }
      qvImgHtml += '</div>';

      // Restore modal HTML structure
      body.innerHTML = qvImgHtml +
        '<div class="qv-info">' +
          '<h2 class="qv-title" id="qvTitle"></h2>' +
          '<div class="qv-price" id="qvPrice"></div>' +
          '<p class="qv-description" id="qvDescription"></p>' +
          '<div class="qv-variants" id="qvVariants" style="display:none">' +
            '<label class="qv-variant-label" id="qvVariantLabel">Select option</label>' +
            '<div class="qv-variant-options" id="qvVariantOptions"></div>' +
          '</div>' +
          '<div class="qv-quantity">' +
            '<label class="qv-variant-label">Quantity</label>' +
            '<div class="qv-qty-wrap">' +
              '<button class="qv-qty-btn" data-qv-qty="-1" aria-label="Decrease quantity">−</button>' +
              '<input type="number" class="qv-qty-input" id="qvQty" value="1" min="1" max="99" aria-label="Quantity">' +
              '<button class="qv-qty-btn" data-qv-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<form id="qvForm">' +
            '<input type="hidden" name="id" id="qvVariantId" value="">' +
            '<input type="hidden" name="quantity" id="qvFormQty" value="1">' +
            '<button type="submit" class="qv-add-btn" id="qvAddBtn">' +
              '<svg viewBox="0 0 24 24" width="18" height="18"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
              'Add to Cart' +
            '</button>' +
          '</form>' +
          '<a class="qv-view-full" id="qvViewFull" href="">View Full Details →</a>' +
        '</div>';

      // Fill in product data — image gallery
      var qvCurrentImg = 0;
      var qvTotalImgs = product.images ? product.images.length : 0;

      if (qvTotalImgs > 1) {
        // Multi-image gallery: wire up arrows + dots
        var qvImgWrap = document.getElementById('qvImageWrap');
        var qvGalleryImgs = qvImgWrap.querySelectorAll('.qv-gallery-img');
        var qvDots = qvImgWrap.querySelectorAll('.qv-img-dot');

        function qvShowImg(idx) {
          if (idx < 0) idx = qvTotalImgs - 1;
          if (idx >= qvTotalImgs) idx = 0;
          qvCurrentImg = idx;
          qvGalleryImgs.forEach(function(img, i) {
            if (i === idx) { img.classList.remove('qv-img-hidden'); } else { img.classList.add('qv-img-hidden'); }
          });
          qvDots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
          /* Scroll dots container to keep active dot centered */
          if (qvDots[idx]) {
            var dotsWrap = qvDots[idx].parentElement;
            if (dotsWrap && dotsWrap.scrollWidth > dotsWrap.clientWidth) {
              var dotCenter = qvDots[idx].offsetLeft + qvDots[idx].offsetWidth / 2;
              dotsWrap.scrollLeft = dotCenter - dotsWrap.clientWidth / 2;
            }
          }
        }

        qvImgWrap.querySelector('[data-qv-arrow="prev"]').addEventListener('click', function() { qvShowImg(qvCurrentImg - 1); });
        qvImgWrap.querySelector('[data-qv-arrow="next"]').addEventListener('click', function() { qvShowImg(qvCurrentImg + 1); });
        qvDots.forEach(function(dot) {
          dot.addEventListener('click', function() { qvShowImg(parseInt(this.getAttribute('data-qv-dot'))); });
        });
      } else {
        // Single image fallback
        var img = document.getElementById('qvImage');
        if (product.featured_image) {
          img.src = product.featured_image;
          img.alt = product.title;
        }
      }

      document.getElementById('qvTitle').textContent = product.title;
      document.getElementById('qvViewFull').href = product.url;

      // Format price with compare-at / MSRP support (Shopify returns price in cents)
      var firstVariant = product.variants[0];
      updateQvPrice(firstVariant);

      // Description (strip HTML, truncate)
      var desc = product.description || '';
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = desc;
      var plainText = tempDiv.textContent || tempDiv.innerText || '';
      if (plainText.length > 200) plainText = plainText.substring(0, 200) + '...';
      document.getElementById('qvDescription').textContent = plainText;

      // Variants
      if (product.variants.length > 1) {
        document.getElementById('qvVariants').style.display = '';

        // Determine the option name (options can be objects with .name or plain strings)
        var rawOpt = product.options[0];
        var optionName = (rawOpt && typeof rawOpt === 'object') ? (rawOpt.name || 'Option') : (rawOpt || 'Option');
        document.getElementById('qvVariantLabel').textContent = optionName;

        var optionsContainer = document.getElementById('qvVariantOptions');
        optionsContainer.innerHTML = '';

        product.variants.forEach(function(variant, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qv-variant-btn' + (i === 0 ? ' active' : '') + (!variant.available ? ' unavailable' : '');
          btn.textContent = variant.title;
          btn.setAttribute('data-variant-index', i);
          if (!variant.available) {
            btn.disabled = true;
          }
          btn.addEventListener('click', function() {
            selectVariant(i);
          });
          optionsContainer.appendChild(btn);
        });
      }

      // Set initial variant
      selectedVariantId = firstVariant.id;
      document.getElementById('qvVariantId').value = firstVariant.id;

      // If first variant unavailable, find first available
      if (!firstVariant.available && product.variants.length > 1) {
        for (var v = 0; v < product.variants.length; v++) {
          if (product.variants[v].available) {
            selectVariant(v);
            break;
          }
        }
      }

      // Update add button state
      updateAddButton();

      // Quantity buttons
      overlay.querySelectorAll('[data-qv-qty]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var input = document.getElementById('qvQty');
          var delta = parseInt(this.getAttribute('data-qv-qty'));
          var newVal = Math.max(1, Math.min(99, parseInt(input.value) + delta));
          input.value = newVal;
          document.getElementById('qvFormQty').value = newVal;
        });
      });

      // Quantity input direct edit
      var qtyInput = document.getElementById('qvQty');
      qtyInput.addEventListener('change', function() {
        var val = Math.max(1, Math.min(99, parseInt(this.value) || 1));
        this.value = val;
        document.getElementById('qvFormQty').value = val;
      });

      // Form submit
      var form = document.getElementById('qvForm');
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var addBtn = document.getElementById('qvAddBtn');
        var variantId = document.getElementById('qvVariantId').value;
        var qty = document.getElementById('qvFormQty').value;

        if (!variantId) return;

        addBtn.textContent = 'Adding...';
        addBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(qty) })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          addBtn.innerHTML = '✓ Added!';
          // Update cart count
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count').forEach(function(b) {
                b.textContent = cart.item_count;
                b.style.display = cart.item_count > 0 ? '' : 'none';
              });
            });

          setTimeout(function() {
            addBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart';
            addBtn.disabled = false;
            closeQuickView();
          }, 1200);
        })
        .catch(function() {
          addBtn.textContent = 'Error — try again';
          addBtn.disabled = false;
          setTimeout(function() {
            addBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart';
          }, 1500);
        });
      });
    }

    function selectVariant(index) {
      if (!currentProductData) return;
      var variant = currentProductData.variants[index];
      if (!variant || !variant.available) return;

      selectedVariantId = variant.id;
      document.getElementById('qvVariantId').value = variant.id;

      // Update price with MSRP/sale support
      updateQvPrice(variant);

      // Update image if variant has one
      if (variant.featured_image) {
        var qvSingleImg = document.getElementById('qvImage');
        if (qvSingleImg) {
          qvSingleImg.src = variant.featured_image.src;
        } else {
          // Multi-image mode: find matching image index and navigate to it
          var qvWrap = document.getElementById('qvImageWrap');
          if (qvWrap) {
            var galleryImgs = qvWrap.querySelectorAll('.qv-gallery-img');
            galleryImgs.forEach(function(gImg, gi) {
              if (gImg.src.indexOf(variant.featured_image.src) > -1 || variant.featured_image.src.indexOf(gImg.getAttribute('src')) > -1) {
                // Found matching image — show it
                galleryImgs.forEach(function(img, i) {
                  if (i === gi) { img.classList.remove('qv-img-hidden'); } else { img.classList.add('qv-img-hidden'); }
                });
                var qvDts = qvWrap.querySelectorAll('.qv-img-dot');
                qvDts.forEach(function(d, i) { d.classList.toggle('active', i === gi); });
              }
            });
          }
        }
      }

      // Update active state
      document.querySelectorAll('.qv-variant-btn').forEach(function(btn, i) {
        btn.classList.toggle('active', i === index);
      });

      updateAddButton();
    }

    function updateAddButton() {
      var addBtn = document.getElementById('qvAddBtn');
      if (!addBtn) return;

      if (!currentProductData) return;

      var variant = null;
      for (var i = 0; i < currentProductData.variants.length; i++) {
        if (currentProductData.variants[i].id === selectedVariantId) {
          variant = currentProductData.variants[i];
          break;
        }
      }

      if (!variant || !variant.available) {
        addBtn.disabled = !isPreorderProduct;
      if(isPreorderProduct){addBtn.style.backgroundColor="#1565c0";addBtn.style.color="#fff";}
        addBtn.textContent = (isPreorderProduct?'Pre-Order':'Sold Out');
      } else {
        addBtn.disabled = false;
      addBtn.style.backgroundColor=isPreorderProduct?"#1565c0":"";addBtn.style.color=isPreorderProduct?"#fff":"";
        addBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> ' + (isPreorderProduct ? 'Pre-Order' : 'Add to Cart') + '';
      }
    }

    function updateQvPrice(variant) {
      var priceEl = document.getElementById('qvPrice');
      if (!priceEl) return;

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      var html = '';

      if (hasCompare) {
        html += '<span class="qv-price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
        html += '<span class="qv-price-current on-sale">' + formatMoney(variant.price) + '</span>';
        var saveAmt = (variant.compare_at_price - variant.price) / 100;
        html += '<span class="qv-price-save">SAVE $' + saveAmt.toFixed(2) + '</span>';
      } else {
        html += '<span class="qv-price-current">' + formatMoney(variant.price) + '</span>';
      }

      priceEl.innerHTML = html;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // Bind Quick View buttons (eye icon on product cards)
    document.querySelectorAll('.pc-quick-view-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = this.getAttribute('data-product-handle');
        if (handle) openQuickView(handle);
      });
    });

    // Bind "Choose Options" buttons (multi-variant Quick Add)
    document.querySelectorAll('.pc-quick-add-btn--variants').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = this.getAttribute('data-product-handle');
        if (handle) openQuickView(handle);
      });
    });
  }

  /* ── Quick Add (single variant, direct add) ── */
  function initQuickAdd() {
    document.querySelectorAll('.pc-quick-add-btn[data-quick-add-id]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = this.getAttribute('data-quick-add-id');
        if (!variantId) return;

        var originalHTML = this.innerHTML;
        this.innerHTML = 'Adding...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.innerHTML = '✓ Added!';
          btn.classList.add('added');

          // Update cart count
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count').forEach(function(b) {
                b.textContent = cart.item_count;
                b.style.display = cart.item_count > 0 ? '' : 'none';
              });
            });

          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
            btn.classList.remove('added');
          }, 1500);
        })
        .catch(function() {
          btn.textContent = 'Error';
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 1500);
        });
      });
    });
  }

  /* ── Initialize everything on DOM ready ── */
  function init() {
    initTabs();
    initFAQ();
    initSearch();
    initContactPaths();
    initDealerCountry();
    initAddToCart();
    initCartPage();
    initQuickView();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /*
   * Refresh cart badge when the page is restored from bfcache (browser back
   * from checkout) or when the tab becomes visible again. Without this, the
   * badge can show a stale count after checkout return because bfcache
   * restores the DOM as it was before navigation.
   */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) refreshCartCount();
  });
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') refreshCartCount();
  });

})();
